export interface GetSeatMapReturnType {
    soldCount:          number;
    maxCanBuy:          number;
    popupNoticeMsg:     string[];
    unpaidOrders:       UnpaidOrder[];
    filmLevelNoticeMsg: string;
    seatCount:          number;
    regular:            number;
    sections:           SectionType[];
    filmLevel:          string;
    notice:             string;
    [key: string]:      any;
}

export interface SectionType {
    sectionName: string;w
    minRow:      number;
    minColumn:   number;
    maxRow:      number;
    sectionId:   string;
    seats:       Seat[];
    maxColumn:   number;
    regular:     number;
    areaInfos:   AreaInfo[];
}

export interface AreaInfo {
    areaPrice:        number;
    lowestPrice:      number;
    areaId:           string;
    areaColor:        string;
    areaName:         string;
    displayPrice:     number;
    ticketTypePrices: TicketTypePrice[];
    areaColorId:      number;
    budgetUsedAmount: number;
}

export interface TicketTypePrice {
    areaPrice:        number;
    ticketTypeSortNo: number;
    lowestPrice:      number;
    displayPrice:     number;
    singleBuyFlag:    SingleBuyFlag;
    ticketTypeId:     string;
    ticketTypeName:   TicketTypeName;
    budgetUsedAmount: number;
}

export enum SingleBuyFlag {
    N = "N",
    Y = "Y",
}

export enum TicketTypeName {
    儿童票 = "儿童票",
    学生票 = "学生票",
    成人票 = "成人票",
    长者票 = "长者票",
}

interface Seat {
    areaId:     string;
    flag:       number;
    rowName:    string;
    column:     number;
    name:       string;
    seatId:     string;
    row:        number;
    columnName: string;
    status:     number;
}

export interface UnpaidOrder {
    cinemaLinkId: string;
    orderType:    string;
    orderId:      string;
}

export interface GetScreenReturnType {
    films:             FilmType[];
    recommendCardInfo: RecommendCardInfo;
    beforeSoldTime:    number;
    specialServices:   any[];
}

export interface FilmType {
    cinemaLinkId:      string;
    filmUniqueId:      string;
    customRating:      string;
    filmId:            string;
    filmLang:          FilmLang;
    rating:            string;
    filmName:          string;
    dates:             DateElementType[];
    poster:            string;
    introduction:      string;
    filmLevel:         string;
    filmShortNameEn:   string;
    filmTrailer?:      string;
    horizontalPoster?: string;
}

export interface DateElementType {
    date:      string;
    schedules: ScheduleType[];
    dateTag:   string;
}

export interface ScheduleType {
    filmSubTitleName: any;
    lowestPrice:           number;
    filmVersionCode:       string;
    filmLang:              FilmLang;
    showTime:              string;
    hallType:              FirstShowFlag;
    standardPrice:         number;
    areaPrices:            AreaPrice[];
    duration:              number;
    originalStandardPrice: string;
    firstShowFlag:         FirstShowFlag;
    displayPrice:          string;
    hallId:                string;
    scheduleKey:           string;
    buyAlone:              boolean;
    endTime:               string;
    hallName:              string;
    starsShowFlag:         FirstShowFlag;
    scheduleId:            string;
    filmVersion:           FilmVersion;
    goodsInfo?:            GoodsInfo;
    ticketFee?:            number;
    startTime:             string;
    dateText:              string;
}

export interface AreaPrice {
    areaId:          string;
    areaName:        AreaName;
    areaSettlePrice: number;
    ticketTypeId:    string;
    areaServiceFee?: number;
}

export enum AreaName {
    中心区域 = "中心区域",
    星耀会员 = "星耀会员",
    普通区 = "普通区",
    最佳觀影區 = "最佳觀影區",
    至尊區 = "至尊區",
    荣耀会员 = "荣耀会员",
    貴賓區 = "貴賓區",
    超级会员区 = "超级会员区",
    邊邊角角 = "邊邊角角",
}

export enum FilmLang {
    中文 = "中文",
    原聲 = "原聲",
    國語 = "國語",
    英語 = "英語",
}

export enum FilmVersion {
    Imax2D = "IMAX2D",
    Imax3D = "IMAX3D",
    The2D = "2D",
    The3D = "3D",
}

export enum FirstShowFlag {
    H = "H",
    N = "N",
    V = "V",
}

export interface GoodsInfo {
    goodsId:      string;
    price:        number;
    count:        number;
    categoryCode: string;
}

export interface RecommendCardInfo {
    cinemaLinkId:             string;
    recommendCardRuleId:      number;
    recommendCardRuleType:    number;
    recommendCardScheduleMsg: string;
}

export interface LockSeatsReturnType {
    lockOrderId: string;
    expireIn:    number;
}

export interface SelectListType {
    areaId:     string;
    flag:       number;
    rowName:    string;
    column:     number;
    name:       string;
    seatId:     string;
    row:        number;
    columnName: string;
    status:     number;
    [key: string]: any;
}

export interface PassType {
    pass:       boolean;
    unpassList: UnpassList[];
}

export interface UnpassList {
    areaId:     string;
    flag:       number;
    rowName:    string;
    column:     number;
    name:       string;
    seatId:     string;
    row:        number;
    columnName: string;
    status:     number;
}